import { motion, AnimatePresence } from "framer-motion"
import axiosInstance from "../../utils/axios/axiosConfig"
import toast from "react-hot-toast"

import { useTranslation } from "react-i18next"
import { AlertTriangle, X } from "lucide-react"

function DeleteModal({ setDeleteId, DeleteId, Model, setDone, setLoding, done, open, setOpen }) {
  const { t } = useTranslation()

  const deleteRecord = async (id) => {
    try {
      setLoding(true)
      const response = await axiosInstance.delete(`/${Model}/delete/${id}`)
      const responseData = response.data
      if (responseData && responseData.statusCode === 200) {
        setDeleteId(null)
        setDone(!done)
        setOpen(false)
        toast.success(responseData.message)
      }
      setLoding(false)
    } catch (error) {
      toast.error(error.response?.data?.message || t("An error occurred"))
      setDeleteId(null)
      setLoding(false)
      console.error("Deletion failed:", error.response?.data)
    }
  }

  return (
    <AnimatePresence>
      {DeleteId && open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/50"
            onClick={() => {
              setDeleteId(null)
              setOpen(false)
            }}
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{
              type: "spring",
              damping: 25,
              stiffness: 300,
            }}
            className="relative w-full max-w-md overflow-hidden rounded-xl bg-white shadow-2xl dark:border-neutral-700 dark:bg-neutral-950/90 backdrop-blur-md"
          >
            {/* Close button */}
            <button
              onClick={() => {
                setDeleteId(null)
                setOpen(false)
              }}
              className="absolute right-4 top-4 rounded-full p-1 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-neutral-300"
            >
              <X size={18} />
            </button>

            {/* Warning icon */}
            <div className="flex flex-col items-center p-6 pt-10 text-center">
              <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-50 dark:bg-red-900/20">
                <AlertTriangle size={40} className="text-red-500 dark:text-red-400" />
              </div>

              <h2 className="mb-2 text-xl font-semibold text-neutral-900 dark:text-white">{t("Confirm Deletion")}</h2>

              <p className="mb-6 text-neutral-600 dark:text-neutral-300">
                {t("Are you sure you want to delete this item? This action cannot be undone.")}
              </p>

              <div className="flex w-full gap-3">
                <button
                  onClick={() => {
                    setDeleteId(null)
                    setOpen(false)
                  }}
                  className="flex-1 rounded-xl border border-neutral-200 bg-white px-4 py-2.5 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50 dark:bg-neutral-800 dark:border-neutral-900 dark:bg-neutral-900 dark:text-neutral-200 dark:hover:bg-neutral-700"
                >
                  {t("Cancel")}
                </button>

                <button
                  onClick={() => deleteRecord(DeleteId)}
                  className="flex-1 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:bg-red-700 dark:hover:bg-red-600 dark:focus:ring-red-600"
                >
                  {t("Delete")}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}

export default DeleteModal
